var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2827",
    "data-name": "Rectangle 2827",
    width: 18,
    height: 18,
    transform: "translate(370.321 293.321)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5888",
    "data-name": "Mask Group 5888",
    transform: "translate(-370.321 -293.321)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6516",
    "data-name": "Group 6516",
    transform: "translate(371.981 296.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6468",
    "data-name": "Group 6468",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7361",
    "data-name": "Path 7361",
    d: "M7.472,25.678H6.18a1.293,1.293,0,0,1-1.293-1.293V15.338A1.293,1.293,0,0,1,6.18,14.045h7.756a1.293,1.293,0,0,1,1.293,1.293V25.678h-5.17",
    transform: "translate(-4.887 -14.045)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7362",
    "data-name": "Path 7362",
    d: "M98.1,70.04h0a1.293,1.293,0,0,1,1.293,1.293v2.585A1.293,1.293,0,0,1,98.1,75.21H97.064",
    transform: "translate(-84.138 -63.577)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_385",
    "data-name": "Ellipse 385",
    cx: 1.293,
    cy: 1.293,
    r: 1.293,
    transform: "translate(2.585 10.341)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_386",
    "data-name": "Ellipse 386",
    cx: 1.293,
    cy: 1.293,
    r: 1.293,
    transform: "translate(10.341 10.341)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2657",
    "data-name": "Rectangle 2657",
    width: 5.17,
    height: 5.17,
    rx: 2,
    transform: "translate(2.585 2.585)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_571",
    "data-name": "Line 571",
    y1: 1.293,
    transform: "translate(5.17 2.585)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7363",
    "data-name": "Path 7363",
    d: "M94.479,36.443h2.327A1.293,1.293,0,0,1,98.1,37.736v2.391",
    transform: "translate(-84.138 -33.858)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipped);
export default __webpack_public_path__ + "static/media/Shipped.25a735a8b3536819fab4fc3e02faae5b.svg";
export { ForwardRef as ReactComponent };